import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button} from 'antd'
import {withTranslation} from 'react-i18next'

@inject('marketingSmsManagementStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
  }
  componentDidMount() {
  }
  handleDelete = (record) => {
    const {marketingSmsManagementStore, type, smsType} = this.props
    const { generateID } = marketingSmsManagementStore
    marketingSmsManagementStore.onClearPhoneAction({
      "sourceType": record?.sourceType,
      "taskGroupId": generateID,
      "id": record?.id
    }).then(res=> {
      if (res?.data?.code === 0) {
        marketingSmsManagementStore.onStatisticsAction({
          "smsType": smsType,
          "taskGroupId": generateID,
          "taskType": type
        })
      }
    })
  }
  handlePageChange = (page, pageSize) => {
    const {marketingSmsManagementStore} = this.props
    marketingSmsManagementStore.onChangePhonePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {marketingSmsManagementStore, t} = this.props
    const {pageNoPhone, pageSizePhone, itemCountPhone, phoneList, sourceTypeList} = marketingSmsManagementStore
    const pagination = getPaginationConfig(pageNoPhone, pageSizePhone, itemCountPhone, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(phoneList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} style={{marginTop: 0, paddingTop: 0}}>
          <Table.Column title={t(`marketingManagement.phoneNumber`)} dataIndex="phone" key="phone" ellipsis={true} render={(text, record) => (
            <div style={record?.isValid === 1 ? {color: 'rgb(255, 51, 51)'} : {}}>
              {text}
            </div>
          )} />
          <Table.Column title={t(`marketingManagement.dataSource`)} dataIndex="sourceType" key="sourceType" ellipsis={true} render={(text, record) => (
            sourceTypeList?.find(a=> a?.code===text)?.name
          )} />
          <Table.Column title={t(`marketingManagement.phoneDesc`)} dataIndex="validDesc" key="validDesc" ellipsis={true} />
          <Table.Column width={150} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleDelete(record)}title={t(`general.delete`)}>{t(`general.delete`)}</Button>
            </>
          )} />
        </Table>
      </>
    )
  }
}

export default withTranslation()(SearchResult)
